import { IntlShape } from 'react-intl';

import { ICard } from '../types';

const createGBBookCarAppointmentCard = (intl: IntlShape): ICard => ({
  id: 'car-book-an-appointment',
  cardStatus: 'todo',
  title: intl.formatMessage({
    defaultMessage: 'Vehicle inspection',
    id: 'rS/SMx',
    description: 'GB Vehicle inspection card: title',
  }),
  desc: intl.formatMessage({
    defaultMessage:
      'To have your vehicle approved, upload all required documents and book a vehicle check at London Academy using the link below. Attend your appointment at the scheduled time.',
    id: 'todo_gb_vehicle_inspection_description',
    description: 'GB Vehicle inspection card: description',
  }),
  actionExternalLink: 'https://cal.com/team/wheely-london-operations/vehicle-checks',
  actionTitle: intl.formatMessage({
    defaultMessage: 'Book appointment',
    id: 'todo_gb_vehicle_inspection_action',
    description: 'GB Vehicle inspection card: action button',
  }),
});

export { createGBBookCarAppointmentCard };
